import { useEffect, useState } from "react";
import { getHiringCompanyWithJobCount } from "@endpoints/recruiter.service";

export interface HiringCompanyWithJobCount {
  hiringCompany: { _id: string; companyName: string };
  totalJobs: number;
}

export const useHiringCompanies = (searchText?: string) => {
  const [hiringCompanies, setHiringCompanies] = useState<
    HiringCompanyWithJobCount[]
  >([]);
  const [data, setData] = useState<HiringCompanyWithJobCount[]>([]);

  useEffect(() => {
    let isCancelled = false;
    getHiringCompanyWithJobCount({ page: 1, limit: 20 })
      .then(({ data, success }) => {
        if (success && !isCancelled) setData(data ?? []);
      })
      .catch(() => {});
    return () => {
      isCancelled = true;
    };
  }, []);

  useEffect(() => {
    if (searchText && data?.length) {
      setHiringCompanies(() =>
        data?.filter((item) =>
          item?.hiringCompany?.companyName?.toLowerCase()?.includes(searchText?.toLowerCase()),
        ),
      );
    } else {
      setHiringCompanies(data);
    }

    return () => {};
  }, [searchText, data]);

  return hiringCompanies;
};
